import React from "react";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { Input } from "./input";
import { Search } from "./search";
import { Zones } from "./zones";
import styles from "./styles.scss";

function ProjectSelection({ selected, placeholder = "", onSelect }: Props) {
  const [search, setSearch] = React.useState("");

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: (
          <Input
            placeholder={placeholder}
            selected={selected}
            isOpen={isOpen}
          />
        ),
        list: (
          <div className={styles.projectsSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Zones
              search={search}
              selected={selected}
              onSelect={(project) => {
                select(project);
                onSelect(project);
              }}
              isOpen={true}
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ProjectSelection };
